<template>

  <v-app id="app">

    <v-overlay :value="overlay">

      <v-progress-circular indeterminate size="64"></v-progress-circular>

    </v-overlay>

    <v-dialog v-model="contactDialog" persistent max-width="600">

      <v-card class="pa-3">

        <v-card-title class="h2 mb-3">

          Contact us

        </v-card-title>

        <v-card-text>

          <p><strong>Phone:</strong> {{ supportPhone }}</p>

          <p><strong>Email:</strong> <a :href="'mailto:' + supportEmail">{{ supportEmail }}</a></p>

        </v-card-text>

        <v-card-actions>

          <span class="text-caption mt-3 text-left pl-3">Application Version 4.4 (App ID: izOnh51B)</span>

          <v-spacer></v-spacer>

          <v-btn @click="contactDialog = false" color="primary">OK</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <header>

      <v-container>

        <v-row no-gutters>

          <v-col sm="3" cols="4">

            <img class="mv-logo mt-2" width="180" src=" https://metrovancouver.org/SiteAssets/img/mv-logo-dark.png"/>

          </v-col>

          <v-col sm="9" cols="8" align="right">

            <v-btn text @click="navigateToDashboard" v-if="$store.state.userProfile && $store.state.userProfile.email != null">Dashboard</v-btn>

            <v-btn text @click="navigateToMyAccount" v-if="$store.state.userProfile && (($store.state.userProfile.role == 'User') || ($store.state.userProfile.role == 'Admin' && $route.query.id != null))">My account</v-btn>

            <v-btn text v-if="$route.query.id == null" @click="contact">Contact</v-btn>

            <v-btn text @click="signout" v-if="$store.state.userProfile && $store.state.userProfile.email != null && $route.query.id == null">Sign out</v-btn>

          </v-col>

        </v-row>

      </v-container>

      <v-toolbar density="compact" class="ribw_header">

        <v-container>

          <v-row no-gutters>

            <v-col cols="12">

              <v-toolbar-title>

                <h1 class="riwb-title">{{ title }}</h1>

              </v-toolbar-title>

            </v-col>

          </v-row>

        </v-container>

      </v-toolbar>

    </header>

    <v-navigation-drawer v-model="drawer" temporary app>

      <v-list nav dense>

        <v-list-item-content>

          <v-list-item key="1" @click="contact">

            <v-list-item-title>Contact us</v-list-item-title>

          </v-list-item>

          <v-list-item key="2" @click="signout" v-show="$store.state.userProfile && $store.state.userProfile.email != null">

            <v-list-item-title>Sign out</v-list-item-title>

          </v-list-item>

        </v-list-item-content>

      </v-list>

    </v-navigation-drawer>

    <v-main>

      <v-container fluid>

        <router-view></router-view>

      </v-container>

    </v-main>

    <v-footer class="bg-white">

      <v-snackbar v-model="$store.state.showCookieBanner" :timeout="-1" color="primary" bottom app multi-line width="100%">

        <v-container fluid class="pa-0">

          <v-row no-gutters>

            <v-col cols="12" class="text-right">

              <v-btn icon @click="closeCookieBanner" class="mr-2">

                <v-icon>mdi-close</v-icon>

              </v-btn>

            </v-col>

            <v-col cols="12" class="pb-2">

              <p class="text-white privacy">

                This website uses cookies to ensure you get the best experience. By continuing to use this site, you accept our use of cookies.

               View our <a href="Privacy" target="_blank">privacy statement</a>.

              </p>

            </v-col>

          </v-row>

        </v-container>

      </v-snackbar>

      <v-layout class="riwb-footer py-4 pr-5 justify-end">

        <span class="caption" >© Metro Vancouver 2024 | <a href="https://metrovancouver.org/Documents/copyright-notice-disclaimer.pdf" target="_blank">Copyright Notice & Disclaimer</a>  | <a href="privacy">Privacy Statement</a>

        </span>

      </v-layout>

    </v-footer>

  </v-app>

</template>

<script>
//
import Vue from 'vue';

import axios from "axios";

export default Vue.extend({

  name: 'App',

  data: () => ({

    title: '',

    overlay: false,

    drawer: false,

    contactDialog: false,

    supportEmail: '',

    supportPhone: ''

  }),

  created()
  {
    this.title = 'Residential Indoor Wood Burning System';

    this.supportEmail = process.env.VUE_APP_SUPPORT_EMAIL;

    this.supportPhone = process.env.VUE_APP_SUPPORT_PHONE;
  },

  methods: {

    closeCookieBanner() {

      // set the show banner to false

      var setCookie = (cName, cValue, expDays) => {

        let date = new Date();

        date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));

        const expires = "expires=" + date.toUTCString();

        document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";

      }

      setCookie('cookiesconsent_showPopup', false, 90);

      this.$store.dispatch('updateShowCookieBanner', false);

    },

    navigateToMyAccount() {

      var url = '/MyAccount';

      if (this.$route.query.id) url += '?id=' + this.$route.query.id;

      this.$router.push(url);

    },

    async contact() {

      this.contactDialog = true;

    },

    async signout() {

      this.overlay = true;

      setTimeout(async () => {

        let obj = await axios.get('accounts/SignOut');

        this.overlay = false;

        if (obj.data == '%%SUCCESS%%') {

          this.$store.dispatch('updateUserProfile', null);

          this.$router.push('/Login');

        }

      }, 100);

    },

    async navigateToDashboard() {

      if (this.$store.state.userProfile.role == "User")
      {
        var url1 = '/Dashboard';

        if (this.$route.query.id != null) url1 += "?id=" + this.$route.query.id;

        this.$router.push(url1);
      }
      else if (this.$store.state.userProfile.role == "Admin")
      {
        if (this.$route.query.id == null) {

          this.$router.push('/Admin/Dashboard');

        }
        else
        {
          var url2 = '/Dashboard?id=' + this.$route.query.id;

          this.$router.push(url2);

        }

      }

    }

  }

});

</script>
